module.exports = __webpack_public_path__ + "static/OB_Wuerzner_by_Salar_Baygan-0708171ff11f2389a71bf78fc7677a3c.jpg";